var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.75V8.625C11 8.83125 10.8313 9 10.625 9H5.375C5.16875 9 5 8.83125 5 8.625V7.75C5 7.54375 5.16875 7.375 5.375 7.375H10.625C10.8313 7.375 11 7.54375 11 7.75ZM10.625 10H5.375C5.16875 10 5 10.1687 5 10.375V11.25C5 11.4563 5.16875 11.625 5.375 11.625H10.625C10.8313 11.625 11 11.4563 11 11.25V10.375C11 10.1687 10.8313 10 10.625 10ZM14 4.12187V14.5C14 15.3281 13.3281 16 12.5 16H3.5C2.67188 16 2 15.3281 2 14.5V1.5C2 0.671875 2.67188 0 3.5 0H9.87813C10.275 0 10.6562 0.159375 10.9375 0.440625L13.5594 3.0625C13.8406 3.34063 14 3.725 14 4.12187ZM10 1.62188V4H12.3781L10 1.62188ZM12.5 14.5V5.5H9.25C8.83437 5.5 8.5 5.16563 8.5 4.75V1.5H3.5V14.5H12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.820fd21ef675747f6901b6759b6eb7ae.svg";
export { ForwardRef as ReactComponent };